/**
 * Utilidades para colores semánticos de LinearGraphic
 */

import { LinearGraphicColor } from '../types';

/**
 * Mapeo de colores semánticos a variables CSS del sistema de diseño
 */
export const SEMANTIC_COLOR_MAP: Record<LinearGraphicColor, string> = {
  brand: 'var(--ui-color-blue-500)',
  success: 'var(--ui-color-green-500)',
  warning: 'var(--ui-color-orange-500)',
  danger: 'var(--ui-color-red-500)',
  info: 'var(--ui-color-cyan-500)',
  neutral: 'var(--ui-color-light-gray-500)',
  yellow: 'var(--ui-color-yellow-500)',
} as const;

/**
 * Colores por defecto si no se proporcionan
 */
export const DEFAULT_COLORS: LinearGraphicColor[] = [
  'brand',
  'success',
  'warning',
  'danger',
  'info',
];

/**
 * Obtiene el valor CSS del color semántico
 */
export const getColorValue = (color: LinearGraphicColor): string => {
  return SEMANTIC_COLOR_MAP[color] || SEMANTIC_COLOR_MAP.neutral;
};

/**
 * Valida y normaliza un color semántico
 */
export const normalizeColor = (color: unknown): LinearGraphicColor => {
  if (typeof color === 'string' && color in SEMANTIC_COLOR_MAP) {
    return color as LinearGraphicColor;
  }
  return 'neutral';
};
